<template>
  <div class="weapon-icon" :class="`weapon-${weapon}`" :title="weaponNames[weapon]" />
</template>

<script>
  const weaponNames = ['Melee', 'Machine Gun', 'Blaster', 'Super Shotgun', 'Rocket Launcher', 'Shaft', 'PnCR', 'Grenade Launcher', 'Void Cannon']

  export default {
    name: 'LeaderbordWeapon',
    props: {
      weapon: {
        type: Number,
      },
    },
    data() {
      return { weaponNames }
    },
  }
</script>

<style lang="postcss">
  .weapon-icon {
    width: 20px;
    height: 20px;
    background-image: url('../assets/weapons_sprite_50.png');
    background-size: 20px;
    background-repeat: no-repeat;
  }

  @for $i from 0 to 8 {
    .weapon-$i {
      /* prettier-ignore */
      background-position: 0 calc(-20 * $(i)px - 1px);
      background-repeat: no-repeat;
    }
  }
</style>
